import React, { Fragment } from 'react'

export const About = () => {
    return (
        <Fragment>
            <h1> About this Application</h1>
            <p> App to search GitHub users</p>
        </Fragment>
    )
}
